import {OperatorStatus} from "~/chat/ts/data/OperatorStatus";

export const OPERATOR_ELECTRON_IPC_RESIZE_WINDOW_ACTION = "resizeWindow";
export const OPERATOR_ELECTRON_IPC_MOVE_WINDOW_ACTION = "moveWindow";
export const OPERATOR_ELECTRON_IPC_DOWNLOAD_BUTTON = "download-button";
export const OPERATOR_ELECTRON_IPC_MINIMIZE_WINDOW_ACTION = "minimizeWindow";
export const OPERATOR_ELECTRON_IPC_FOCUS_WINDOW_ACTION = "focusWindow";
export const OPERATOR_ELECTRON_IPC_GET_WINDOW_SIZE_ACTION = "getWindowSize";
export const OPERATOR_ELECTRON_IPC_OPEN_DEV_TOOLS_ACTION = "openDevTools";
export const OPERATOR_ELECTRON_IPC_EXIT_ACTION = "exit";
export const OPERATOR_ELECTRON_IPC_UPDATE_BADGE_ACTION = "update-badge";
export const OPERATOR_ELECTRON_IPC_SET_WINDOW_ICON_ACTION = "set-window-icon";
export const OPERATOR_ELECTRON_IPC_CREATE_NOTIFICATION_ACTION = "notification-create";
export const OPERATOR_ELECTRON_IPC_RESIZE_NOTIFICATION_ACTION = "notification-resize";
export const OPERATOR_ELECTRON_IPC_MOVE_NOTIFICATION_ACTION = "notification-move";
export const OPERATOR_ELECTRON_IPC_SHOW_NOTIFICATION_ACTION = "notification-show";
export const OPERATOR_ELECTRON_IPC_CLOSE_NOTIFICATION_ACTION = "notification-close";
export const OPERATOR_ELECTRON_IPC_NOTIFICATION_WINDOW_CLOSE_ACTION = "notification-window-close";
export const OPERATOR_ELECTRON_IPC_NOTIFICATION_WINDOW_BUTTON_ACTION = "notification-window-action";
export const OPERATOR_ELECTRON_IPC_NOTIFICATION_WINDOW_CLICK_ACTION = "notification-window-click";
export const OPERATOR_ELECTRON_IPC_RIGHT_CLICK = "right-click";
export const OPERATOR_ELECTRON_IPC_CONFIG_RELOAD = "config-reload";
export const OPERATOR_ELECTRON_IPC_IS_AUTO_START_ENABLED = "is-autostart-enabled";
export const OPERATOR_ELECTRON_IPC_SET_AUTO_START_ENABLED = "set-autostart-enabled";
export const OPERATOR_ELECTRON_IPC_GET_SYSTEM_IDLE_STATE = "get-system-idle-state";
export const OPERATOR_ELECTRON_IPC_GET_SYSTEM_IDLE_TIME = "get-system-idle-time";
export const OPERATOR_ELECTRON_IPC_CHANGE_STATUS = "electron-change-status";
export const OPERATOR_ELECTRON_IPC_LOGOUT = "electron-logout";
export const OPERATOR_ELECTRON_CONSOLE_LOG = "console-log";
export const OPERATOR_ELECTRON_IPC_GET_AVAILABLE_SPELLCHECK_LANGUAGES = "get-available-spellcheck-languages";
export const OPERATOR_ELECTRON_IPC_SET_SPELLCHECK_LANGUAGES = "set-spellcheck-languages";


export const OPERATOR_ELECTRON_GET_APP_VERSION = "electron-get-app-version";
export const OPERATOR_ELECTRON_GET_APP_BRAND = "electron-get-app-brand";
export const OPERATOR_ELECTRON_GET_DEFAULT_DOWNLOAD_PATH = "electron-get-default-download-path";
export const OPERATOR_ELECTRON_SELECT_PATH = "electron-select-path";
export const OPERATOR_ELECTRON_GET_OS_ARCH = "electron-get-os-arch";

export const OPERATOR_ELECTRON_IPC_OPEN_APP_URL = "open-app-url";
export const OPERATOR_ELECTRON_IPC_DISPLAY_CHANGE = "display-change";
export const OPERATOR_ELECTRON_IPC_FOCUS_CHANGE = "focus-change";
export const OPERATOR_ELECTRON_URL_SCHEME = "onlinechat";

export const OPERATOR_ELECTRON_FETCH_UPDATE = "electron-fetch-update";
export const OPERATOR_ELECTRON_APPLY_UPDATE = "electron-apply-update";


export const OPERATOR_ELECTRON_IPC_SELECT_MESSAGE_TEMPLATE_ACTION = "select-message-template";
export const OPERATOR_ELECTRON_IPC_ANSWER_ON_MESSAGE_ACTION = "answer-on-message";
export const OPERATOR_ELECTRON_IPC_COPY_MESSAGE_ACTION = "copy-message";
export const OPERATOR_ELECTRON_IPC_COPY_SELECTED_MESSAGES_ACTION = "copy-selected-messages";

export interface OperatorElectronCredentials {
    login: string;
    password: string;
}

export interface OperatorElectionFetchUpdateInterface {
    url: string;
    isPartial: boolean;
}

export interface OperatorElectronIpcConfigReloadData {
    translate: {
        addToDictionary: string;
        copy: string;
        copyLink: string,
        paste: string;
        quit: string;
        openWindow: string;
        online: string;
        away: string;
        logout: string;
        invisible: string;
    },
    darkThemeEnabled: boolean;
    isAuthorized: boolean;
    login?: string;
    minimizeToTray: boolean;
    currentStatusId: OperatorStatus;
}